@if (!minimized) {
  <div class="panel">
    @if (autoReplyVisible) {
      <stch-alert
        class="px-4 py-4"
        type="info"
        message="Auto-reply is turned on"
        actionLabel="Turn Off"
        [showTitle]="false"
        (actionClick)="handleAutoReplyTurnOff()"
      />
    }
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis">
          {{ sidebarFilter | titleByMessagesFilter: containerName: true }}
          @if (isAdvancedSearchApplied()) {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
        >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'messages') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appMessagesListContextMenu
            [appMessagesListContextMenuWithAdvancedSearch]="true"
            [appMessagesListContextMenuWithToSort]="sidebarFilter !== 'bulk' && sidebarFilter !== 'spam' && sidebarFilter !== 'inbox' && sidebarFilter !== 'other_mail'"
            [appMessagesListContextMenuWithFromSort]="sidebarFilter !== 'sent' && sidebarFilter !== 'draft' && sidebarFilter !== 'scheduled'"
            [appMessagesListContextMenuWithUnreadFilter]="sidebarFilter !== 'sent' && sidebarFilter !== 'draft' && sidebarFilter !== 'scheduled'"
            [appMessagesListContextMenuWithThreadedView]="sidebarFilter === 'inbox' || sidebarFilter === 'sent'"
          />
        }
        @if (selectedTab === 'folders') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appMessagesFoldersListContextMenu
            [appMessagesFoldersListContextMenuWithAdvancedSearch]="true"
          />
        }
      </div>
      @if (listState === 'tabs') {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [value]="selectedTab"
          (valueChange)="handleSelectedTabChange($event)"
        />
      }
    </div>
    <div class="panel-list">
      @if (selectedTab === 'messages' && messagesFilters) {
        <app-messages2-list
          [filters]="messagesFilters"
          [debug]="debug"
          [showLocationBadge]="isAdvancedSearchApplied()"
          (loadInProgress)="loading = $event"
          (openMessage)="handleClickMessage($event)"
          (clickMessage)="handleClickMessage($event)"
          (clickThreadMessage)="handleClickThreadMessage($event)"
          (doubleClickMessage)="handleDoubleClickMessage($event)"
          (pendingMessage)="handlePendingMessage($event)"
        />
      }
      @if (selectedTab === 'folders' && foldersFilters) {
        <app-message-folders-list
          [filters]="foldersFilters"
          [debug]="debug"
          (loadInProgress)="loading = $event"
          (openFolder)="handleClickFolder($event)"
          (openMessage)="handleClickMessage($event)"
          (clickFolder)="handleClickFolder($event)"
          (doubleClickFolder)="handleDoubleClickFolder($event)"
        />
      }
    </div>
  </div>
}
